import { Features, isFeatureEnabled } from '../../../../featureToggles/features';
import { PaymentOptions } from './types';

interface IOption {
  label: string;
  key: string;
  value: PaymentOptions;
}

const isPlgExternal3Env = isFeatureEnabled(Features.PlgExternal3);

export const PaymentOptionsForSelect: ReadonlyArray<IOption> = [
  {
    label: 'Bulk',
    key: 'Bulk',
    value: PaymentOptions.Bulk
  },
  {
    label: 'Credit Card',
    key: 'Credit Card',
    value: PaymentOptions.CreditCard
  },
  {
    label: 'Invoice',
    key: 'Invoice',
    value: PaymentOptions.Invoice
  },
  {
    key: 'Project Services',
    label: isPlgExternal3Env ? 'Research Services' : 'Project Services',
    value: PaymentOptions.ServiceProject
  }
];
